var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "favouriteBtn",
      attrs: { disabled: _vm.is_favouriting },
      on: {
        click: function($event) {
          return _vm.favourite()
        }
      }
    },
    [
      _c("span", {
        staticClass: " fa-star",
        class: { far: !_vm.favourited, fas: _vm.favourited }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }